export default "__VITE_ASSET__CfyRMGyA__"